import { Card, CardContent } from '@/components/ui/card'
import { BanknoteIcon, UserIcon } from 'lucide-react'
import { useCalculator } from '@/contexts/CalculatorContext'

export function MarginBonusCard() {
  const { 
    margin, 
    nastupy,
    mdsPerMonth,
    currentPeriod,
    getAllPeriods,
    getMarginPercentage,
    getNastupyPercentage,
    calculate1MarginProfit,
  } = useCalculator()

  const periodData = getAllPeriods()
  const previousPeriod = currentPeriod > 0 ? periodData[currentPeriod - 1] : null
  // const nextPeriod = currentPeriod < periodData.length - 1 ? periodData[currentPeriod + 1] : null
  const previousIsKpiMet = previousPeriod ? previousPeriod.isKpiMet : false
  const previousBonus = previousPeriod ? previousIsKpiMet ? getNastupyPercentage(previousPeriod.nastupy) : 0 : 0

  return (
    <Card className={`transition-all duration-300 border-2 ${
      nastupy === 0 ? "border-red-500 bg-red-50" : "border-green-500 bg-green-50"
    } relative`}>
      <CardContent className="pt-6">
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <BanknoteIcon className={`w-4 h-4 ${
                nastupy === 0 ? 'text-orange-500' : 'text-green-500'
            }`}/>
            <span className="font-medium">1. složka</span>
            {nastupy > 0 ? (<span/>) : (
                <span className="text-xs text-orange-500 text-muted-foreground">
                {nastupy === 0 ?
                    'Přidejte nástupy pro aktivaci' :
                    'Maržový bonus aktivní'}
              </span>
            )}
          </div>
          <div className="space-y-2">
            <div className="flex justify-between items-center w-full">
              <span className="text-2xs text-muted-foreground">
                {margin.toLocaleString()} Kč × {nastupy} <UserIcon className="w-3 h-3 inline text-muted-foreground"/> × 6 měsíců × <br/>({getMarginPercentage(margin)}% + {previousBonus}%) × {mdsPerMonth} MDs / 2
              </span>
              <span className="text-2xl font-bold">
                {Math.round(calculate1MarginProfit(margin, previousBonus, nastupy) / 2).toLocaleString()} Kč
              </span>
            </div>
          </div>
          <div className="w-full pt-2 border-t">
            <div className="text-sm text-muted-foreground text-xs">
              Pozn. / 2 ... Kandidáti nastupují průběžně rovnoměrně každý měsíc jeden kandidát od 1. v měsíci<br/>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
} 